import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {closeInviteTeammatePopoverAction} from '../../../store/panels/app/appPanelActions';
import {makeGetInviteTeammatePopoverOpen} from '../../../store/panels/app/appPanelSelectors';
import {AppPanelId} from '../../../store/panels/panelStateBase';
import {InviteTeammatePopover} from './inviteTeammatePopover';

/*
 * Props.
 */

interface InviteTeammatePopoverContainerProps {
  panelId: AppPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InviteTeammatePopoverContainerProps>()(() => ({
  state: makeGetInviteTeammatePopoverOpen(),
}));

const mapDispatchToProps = makeMapDispatchToProps<InviteTeammatePopoverContainerProps>()(({panelId}) => ({
  onRequestClose: () => closeInviteTeammatePopoverAction(panelId),
}));

export const InviteTeammatePopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InviteTeammatePopover);
